// extracted by mini-css-extract-plugin
module.exports = {"scroll-top":"btnHomeAndScrollTop_scroll-top__Bw5x1","btn-home":"btnHomeAndScrollTop_btn-home__w6HZP"};